export const DOMAIN_STATUS = {
    success: {
        statusColor: 'green',
        statusKey: 'success',
        type: ''
    },
    pending: {
        statusColor: 'orange',
        statusKey: 'pending',
        type: 'default'
    },
    failed: {
        statusColor: 'red',
        statusKey: 'failed',
        type: 'danger'
    },
    default: {
        statusColor: 'orange',
        statusKey: 'unstarted',
        type: ''
    }
};
